var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page A4"},[_c('header',{ref:"header"},[_vm._t("header")],2),_c('main',{ref:"main"},[_vm._t("default")],2),(_vm.showPageNumber)?_c('div',{staticClass:"pageNumber"},[_vm._v(" Seite "+_vm._s(_vm.pageNumber)+" "),(_vm.pageCount)?_c('span',[_vm._v("/ "+_vm._s(_vm.pageCount))]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }